<ym-input [type]="'number'" [showLabel]="showLabel" [value]="value" [label]="label" [name]="name" [required]="required"
    [hideOptional]="hideOptional" [inlineInfo]="inlineInfo" [error]="error" [errorText]="errorText"
    [disabled]="disabled" [placeholder]="''" (valueChange)="updateValue($event)"></ym-input>